import { useFlag } from '@rsos/flags';
import AirAmbulancePane from './AirAmbulancePane';

interface AirAmbulancePaneGuardProps {
  hasAccessToUniteEventPane: boolean;
  showCallPane: boolean;
  isMapInitialized: boolean;
  irpAccessToken: string | null | undefined;
  showAirAmbulancePane: boolean;
  onViewJurisdiction: () => void;
}

/**
 * Renders the legacy standalone Air Ambulance pane only when the new generic
 * resource request queue is disabled.
 */
function AirAmbulancePaneGuard({
  hasAccessToUniteEventPane,
  showCallPane,
  isMapInitialized,
  irpAccessToken,
  showAirAmbulancePane,
  onViewJurisdiction,
}: AirAmbulancePaneGuardProps): JSX.Element | null {
  const hasGenericResourceRequests = useFlag('generic_resource_requests');

  if (
    hasGenericResourceRequests ||
    !hasAccessToUniteEventPane ||
    showCallPane ||
    !(isMapInitialized || irpAccessToken) ||
    !showAirAmbulancePane
  ) {
    return null;
  }

  return <AirAmbulancePane onViewJurisdiction={onViewJurisdiction} />;
}

export default AirAmbulancePaneGuard;
